import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { showApiErrorToast } from '@/utils/errors';
import { instituteTypeQueryKeys, updateInstituteType } from '../api/instituteTypes.api';
import type { UpdateInstituteTypePayload } from '../types/instituteType.types';

interface UpdateInstituteTypeArgs {
  id: number;
  payload: UpdateInstituteTypePayload;
}

export function useUpdateInstituteType(onSuccess?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, payload }: UpdateInstituteTypeArgs) => updateInstituteType(id, payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: instituteTypeQueryKeys.all() });
      toast.success('Institute type updated successfully');
      onSuccess?.();
    },
    onError: (error) => {
      showApiErrorToast(error, 'Failed to update institute type');
    },
  });
}
